// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const hireCardNameSelectorActions = require('actions/hireCardNameSelector');
const hireContactDataActions = require('actions/hireContactData');
const hireCreditLimitActions = require('actions/hireCreditLimit');
const hireInformationActions = require('actions/hireInformation');
const hirePaymentMethodActions = require('actions/hirePaymentMethod');
const hireCardCreditINE = require('actions/commons/hireCardCreditINE');
const { updateConsents } = require('actions/gdprConsents');
const { setShippingAddress, resetShippingAddress } = require('actions/shippingAddress');
const { resetPreContractualInfo } = require('actions/preContractualInfo');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');
const { setTermsAndCondsInfoRevolving } = require('actions/cardRevolvingDocuments');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const {
  getCardStandard,
  getCreditCardHiringStatus,
  getShippingAddressDetails,
} = require('utilities/hireCardsHelper');
const { getCCOfficeChannel, isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const { get } = require('lodash');

// @ constants
const actionTypes = require('constants/actionTypes');
const { API_CHANNEL, THIRD_STEP, CREDIT_CARD_SUBTYPE_VISA, CREDIT_CARD_TYPE_VISA } = require('constants/index');
const { NEW_SHIPPING_ADDRESS } = require('constants/shippingAddress');
const { CREDIT_CARD_REVOLVING_PROCESS, MESSAGE_HIRE_24H } = require('constants/flagBasedFeatures');
const { formatText } = require('core/i18n').i18n;

function resetWizard() {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_RESET,
  };
}

const reset = () => dispatch => {
  dispatch(hireCardImageSelectorActions.reset());
  dispatch(hireCardNameSelectorActions.reset());
  dispatch(hireCreditLimitActions.reset());
  dispatch(hireInformationActions.reset());
  dispatch(hirePaymentMethodActions.reset());
  dispatch(hireContactDataActions.reset());
  dispatch(resetShippingAddress());
  dispatch(resetWizard());
  dispatch(resetPreContractualInfo());
};

function onHandleChangeCheckBoxCC() {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_SET_AGREEMENT_CHECKBOX_CC
  };
}

function setAccount(accountId) {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_SET_ACCOUNT,
    payload: {
      accountId,
    },
  };
}

const setAgreementCheckbox = (evt, stepToUpdate = undefined) => {
  const { checked } = evt.target;
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_SET_AGREEMENT_CHECKBOX,
    payload: {
      checked,
      stepToUpdate,
    },
  };
};

function setVisibleStep(step) {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_SET_VISIBLE_STEP,
    payload: {
      step,
    },
  };
}

function processEmailSuccess() {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_CREDIT_PROCCESS_EMAIL_SUCCESS,
  };
}
function processEmailError() {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_CREDIT_PROCCESS_EMAIL_ERROR,
  };
}

function validateAccount() {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_VALIDATE_ACCOUNT,
  };
}

function validateLoading(loadingFlag) {
  return {
    type: actionTypes.HIRE_CARD_LOADING,
    payload: {
      loadingFlag,
    },
  };
}

function validate(step, externalComponentsAreValid, isRevolving = false, ineDir) {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_VALIDATE_STEP,
    payload: {
      step,
      valid: externalComponentsAreValid,
      isRevolving,
      ineDir
    },
  };
}

function hireCardNerudaPrintDocument(value) {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_PRINT_DOCUMENT,
    payload: {
      value,
    },
  };
}

function hireCardNerudaprintDocumentPolicy() {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_PRINT_DOCUMENT_POLICY,
  };
}

function hireCardNerudaCheckedRadioButton(check) {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_CHECK_RADIO_BUTTON,
    payload: {
      check,
    },
  };
}

function hireCardNerudaCheckedRadioButtonPolicy(check) {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_CHECK_RADIO_BUTTON_POLICY,
    payload: {
      check,
    },
  };
}
function hireCardNerudaCheckedRadioButtonIneDir(documentsList, dmsDocumentType, documentChanges) {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_CHECK_RADIO_BUTTON_INE_DIR,
    payload: { documentsList, dmsDocumentType, documentChanges }
  };
}
function agreeIneCheckbox() {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_AGREEINECHECKBOX,

  };
}
const hireCreditCardDocumentRead = (documentType) => {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_DOCUMENT_READ,
    payload: {
      documentType
    }
  }
}
const hireCreditCardAllDocumentRead = () => {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_ALL_DOCUMENT_READ
  }
}
const hireCreditCardsaveDocumentAccepted = (documentsList, dmsDocumentType, documentChanges) => {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_SAVE_DOCUMENT_ACCEPTED,
    payload: { documentsList, dmsDocumentType, documentChanges }
  }
}
const validateFirstAndFifthStep = step => (dispatch, getState) => {
  const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
  dispatch(validate(step, false, showIneAndRevolving));
};

const validateSecondStep = step => (dispatch, getState) => {
  const immHireCardImageSelector = getState().hireCardImageSelector;
  const externalComponentsAreValid = immHireCardImageSelector.get('valid');
  dispatch(validate(step, externalComponentsAreValid));
};

const validateThirdStep = step => (dispatch, getState) => {
  const immHirePaymentMethod = getState().hirePaymentMethod;
  const immHireCreditLimit = getState().hireCreditLimit;
  const accountIsValid = getState().hireCreditCard.getIn(['steps', step - 1, 'accountIsValid']);
  let allComponentsAreValid =
    immHirePaymentMethod.get('valid') && immHireCreditLimit.get('valid') && accountIsValid;

  if (
    allComponentsAreValid &&
    immHireCreditLimit.get('maxValueToAuthorize') > 0 &&
    immHireCreditLimit.get('creditLimit') > immHireCreditLimit.get('maxValueToAuthorize') &&
    immHireCreditLimit.get('minValue') < immHireCreditLimit.get('maxValueToAuthorize')
  ) {
    dispatch(hireCreditLimitActions.toggleModal(true));
  } else {
    dispatch(validate(step, allComponentsAreValid));
  }
};

const validateFourthStep = step => (dispatch, getState) => {
  const immShippingAddress = getState().shippingAddress;
  const shippingAddressType = immShippingAddress.get('shippingAddressType');
  let allComponentsAreValid = true;

  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    //Send param false in validateStep to show absence of mobile field
    dispatch(hireContactDataActions.validateStep(false));

    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid');

    dispatch(validate(step, allComponentsAreValid));

    //Set shipping address as new correspondance address
    allComponentsAreValid && dispatch(setShippingAddress(NEW_SHIPPING_ADDRESS, immHireContactData));
  } else {

    dispatch(validate(step, allComponentsAreValid));

  }
};

const validateINEStep = step => (dispatch, getState) => {
  const immShippingAddress = getState().shippingAddress;
  const shippingAddressType = immShippingAddress.get('shippingAddressType');
  let allComponentsAreValid = true;
  const immHireCardNeruda = getState().hireCreditCard;
  const documentINE = immHireCardNeruda.get('documentINE');
  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    //Send param false in validateStep to show absence of mobile field
    dispatch(hireContactDataActions.validateStep(false));
    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid');
    dispatch(validate(step, allComponentsAreValid))
    dispatch(setShippingAddress(NEW_SHIPPING_ADDRESS, immHireContactData));
    return !documentINE && dispatch(hireCardCreditINE.getInitINEstep(immHireCardNeruda));
  } else {
    dispatch(validate(step, allComponentsAreValid))
    return !documentINE && dispatch(hireCardCreditINE.getInitINEstep(immHireCardNeruda));
  }
};
const validateINEDIRStep = step => (dispatch, getState) => {
  const immShippingAddress = getState().shippingAddress;
  const shippingAddressType = immShippingAddress.get('shippingAddressType');
  let allComponentsAreValid = true;
  const immHireCardNeruda = getState().hireCreditCard;
  const documentINE = immHireCardNeruda.get('documentINE');
  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    //Send param false in validateStep to show absence of mobile field
    dispatch(hireContactDataActions.validateStep(false));
    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid');
    dispatch(validate(step, allComponentsAreValid, true))
    dispatch(setShippingAddress(NEW_SHIPPING_ADDRESS, immHireContactData));
    return !documentINE && dispatch(hireCardCreditINE.getInitINEDIRstep(immHireCardNeruda));
  } else {
    dispatch(validate(step, allComponentsAreValid, true))
    return !documentINE && dispatch(hireCardCreditINE.getInitINEDIRstep(immHireCardNeruda));
  }
};
const validatePolicyStep = () => (dispatch, getState) => {
  const immHireCardNeruda = getState().hireCreditCard;
  const documentPolicy = immHireCardNeruda.get('documentPolicy')
  !documentPolicy && dispatch(hireCardCreditINE.getInitPolicystep(immHireCardNeruda));
};

const getStep = step => (dispatch, getState) => {
  const valid = getState().hireCreditCard.getIn(['steps', step - 1, 'valid']);
  if (!valid) {
    scrollToTop();
  }
  return valid;
};

const processEmail = () => (dispatch, getState) => {
  const productType = getState().hireCreditLimit.get('productType');
  const productSubType = getState().hireCreditLimit.get('productSubType');
  const standard = getState().hireCreditLimit.get('referenceStandard');
  const immHireCardNeruda = getState().hireCreditCard;
  const documentId = immHireCardNeruda.get('documentId')
  const operationProcessIdInit = immHireCardNeruda.get('operationProcessIdInit')

  let acceptanceText;
  if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
    acceptanceText = 'NA'
  }
  if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
    acceptanceText = formatText('hireCardOpenCreditStepINE-titlePdf')
  }
  if (!__CONTACT_CENTER__) {
    acceptanceText = formatText('hireCardOpenCreditStepINE-labelCheckbox')
  }

  const documentIdDIR = immHireCardNeruda.get('documentIdDIR')

  const params = {
    query: {

      product: {
        type: productType,
        subtype: productSubType,
        standard: standard
      },
      contactCenter: false,
      sendInsuranceDocument: true,
      sendRelevantRevolvingDocument: false,
      documentId,
      contractNumber: 0,
      mailType: "precontractual",
      operationProcessId: operationProcessIdInit,
      acceptanceText,
      documents: [
        {
          documentId: immHireCardNeruda.get('documentIdINE'),
          scrollDown: true,
        },
        ...(documentIdDIR ? [{
          documentId: documentIdDIR,
          scrollDown: true,
        }] : [])
      ],
    }
  };
  return APIPost({
    dispatch,
    endpoint: 'hiringCardsSimple',
    params
  })
    .then(() => {
      dispatch(processEmailSuccess());
    })
    .catch(response => {
      if (!!response.error) {
        dispatch(processEmailError());
      }
    });
};

const validateStep = step => (dispatch, getState) => {
  const cardsFeatureFlag = getState().flagBasedFeatures
  const immHireCreditCard = getState().hireCreditCard;
  const policyDocument = immHireCreditCard.get('documentPolicy')

  if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
    if (step === 1 && cardsFeatureFlag.get(MESSAGE_HIRE_24H)) {
      const immCards = getState().cards;
      const immCardById = immCards && immCards.get('byId');
      const immCardByOrder = immCards && immCards.get('byOrder');

      const cardObj =
        immCardByOrder &&
        immCardByOrder.map(cardId => {
          const immCard = immCardById && immCardById.get(cardId);
          return {
            contractNumber: immCard.getIn(['contract', 'number']),
            pan: immCard.get('number'),
            product: immCard.get('newProduct'),
            subType: immCard.get('productSubType'),
            standard: immCard.getIn(['product', 'standard']),
          };
        });
      dispatch(validateLoading(true));
      return APIPost({
        dispatch,
        endpoint: 'validateCardHire',
        params: {
          query: { cards: cardObj },
        },
      })
        .then(() => {
          dispatch(validateLoading(false));
          dispatch(validate(step, false));
        })
        .catch(error => {
          if (error) {
            if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
              dispatch(validate(step, true));
              dispatch(validateLoading(false));
            } else {
              dispatch(hireCardNerudaFailure());
              dispatch(validateLoading(false));
            }
          }
        });
    } else if (step === 2) {
      //SECOND_STEP
      dispatch(hireCardImageSelectorActions.validateStep());
      dispatch(validateSecondStep(step));
    } else if (step === 3) {
      //THIRD_STEP
      dispatch(validateAccount());
      dispatch(hireCreditLimitActions.validateStep());
      dispatch(hirePaymentMethodActions.validateStep());
      dispatch(validateThirdStep(step));
    } else if (step === 4) {
      //FOURTH_STEP
      dispatch(validateINEStep(step))
        .then(() => {
          dispatch(validatePolicyStep());
        })
    } else if (step === 1 || step === 5) {
      //FIRST_STEP AND FIFTH_STEP
      dispatch(validateFirstAndFifthStep(step));
    } else {
      dispatch(validateLoading(false));
      dispatch(validate(step, false));
    }
    return dispatch(getStep(step));

  } else {

    if (step === 1 && cardsFeatureFlag.get(MESSAGE_HIRE_24H)) {
      const immCards = getState().cards;
      const immCardById = immCards && immCards.get('byId');
      const immCardByOrder = immCards && immCards.get('byOrder');

      const cardObj =
        immCardByOrder &&
        immCardByOrder.map(cardId => {
          const immCard = immCardById && immCardById.get(cardId);
          return {
            contractNumber: immCard.getIn(['contract', 'number']),
            pan: immCard.get('number'),
            product: immCard.get('newProduct'),
            subType: immCard.get('productSubType'),
            standard: immCard.getIn(['product', 'standard']),
          };
        });
      dispatch(validateLoading(true));
      return APIPost({
        dispatch,
        endpoint: 'validateCardHire',
        params: {
          query: { cards: cardObj },
        },
      })
        .then(() => {
          dispatch(validateLoading(false));
          dispatch(validate(step, false));
        })
        .catch(error => {
          if (error) {
            if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
              dispatch(validate(step, true));
              dispatch(validateLoading(false));
            } else {
              dispatch(hireCardNerudaFailure());
              dispatch(validateLoading(false));
            }
          }
        });
    } else if (step === 2) {
      dispatch(hireCardImageSelectorActions.validateStep());
      dispatch(validateSecondStep(step));
    } else if (step === 3) {
      dispatch(validateAccount());
      dispatch(hireCreditLimitActions.validateStep());
      dispatch(hirePaymentMethodActions.validateStep());
      dispatch(validateThirdStep(step));
    } else if (step === 4) {
      dispatch(validateINEDIRStep(step))
    } else if (step === 5) {
      !policyDocument && dispatch(processEmail())
        .then(() => {
          dispatch(validatePolicyStep());
        })
      dispatch(validateFourthStep(step));
      !isPrintOfficeMode() && dispatch(agreeIneCheckbox())
    } else if (step === 1 || step === 6) {
      dispatch(validateFirstAndFifthStep(step));
    } else {
      dispatch(validateLoading(false));
      dispatch(validate(step, false));
    }
    return dispatch(getStep(step));
  }

};

const setCardHire = (dispatch, data, termsAndsCondsHiringData, showIneAndRevolving) => {
  const requestData = {
    query: data,
  };

  dispatch(hireCardNerudaRequest());
  return APIPost({
    dispatch,
    endpoint: 'myCardsTarjetasHire',
    params: requestData,
  })
    .then(response => {
      const status = getCreditCardHiringStatus(response);

      if (status.error) {
        dispatch(hireCardNerudaFailure(status.hiringStatus, status.errorMsg));
      } else {
        dispatch(hireCardNerudaSuccess(status.hiringStatus));
        const contractNumber = get(response, ['contratoTarjetaAltOnline', 'numeroContrato'], null);
        if (showIneAndRevolving && contractNumber) {
          dispatch(
            setTermsAndCondsInfoRevolving(
              OPEN_CREDIT_CARD_PRODUCT_ALIAS,
              termsAndsCondsHiringData,
              contractNumber
            )
          );
        } else {
          dispatch(setTermsAndCondsInfo(OPEN_CREDIT_CARD_PRODUCT_ALIAS, termsAndsCondsHiringData));
        }
      }
    })
    .catch(response => {
      const status = getCreditCardHiringStatus(response);
      if (status.error) {
        dispatch(hireCardNerudaFailure(status.hiringStatus, status.errorMsg));
      } else if (!!response.error) {
        dispatch(hireCardNerudaFailure());
      } else {
        throw response;
      }
    });
};

function setWillCancel(willCancel) {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_WILL_CANCEL,
    payload: {
      willCancel,
    },
  };
}
function setCardType(cardType) {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_TYPE,
    payload: {
      cardType,
    },
  };
}

const getCardData = (cardType, field) => (dispatch, getState) => {

  const cardDataMap = {
    'neruda': [{ type: '500', subtype: '802', standard: '0000014', }],
    'vanity': [{ type: '500', subtype: '805', standard: '0000001', }],
    'diamond': [{ type: '501', subtype: '002', standard: '0000022' }],
    'open-credit': [{ type: '500', subtype: '801', standard: '0000028' }],
    'premium': [{ type: '501', subtype: '003', standard: '0000022' }],
  };
  const cardData = cardDataMap[cardType];

  if (!cardData) {
    return null;
  }

  const fieldValues = cardData.map(data => data[field]);
  return fieldValues.length > 0 ? fieldValues[0] : null;
};
const myCardsTarjetasHire = () => (dispatch, getState) => {
  const immHireCardNeruda = getState().hireCreditCard;
  const callback = (dispatch, getState, dataToken) => {
    const contractNumberAccount = immHireCardNeruda.get('contractNumberAccount')
    const cardType = immHireCardNeruda.get('cardType')
    const immCreditLimit = getState().hireCreditLimit;
    const immPaymentMethod = getState().hirePaymentMethod;
    const cardDesignKey = getCardStandard(getState().hireCardImageSelector.get('selectedImageId'));
    const email = PersonalDataHelper.getEmail(getState().profile);
    const immShippingAddress = getState().shippingAddress;
    const shippingAddressType = immShippingAddress.get('shippingAddressType');
    const immHireCardNameSelector = getState().hireCardNameSelector;
    const selectedName = immHireCardNameSelector.getIn([
      'names',
      immHireCardNameSelector.get('selectedIndex'),
    ]);
    const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
    let addressDetails,
      numDomicilio = null;

    if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
      const immContactData = getState().hireContactData;
      addressDetails = getShippingAddressDetails(immContactData);
    } else {
      numDomicilio = immShippingAddress.getIn(['shippingAddress', 'numDomicilio']);
    }
    const acceptanceText = __CONTACT_CENTER__ && !isPrintOfficeMode() ? 'NA' : formatText('hireCreditCard-textInfoIneDir')

    const standard = dispatch(getCardData(cardType, 'standard'))
    const subTipo = dispatch(getCardData(cardType, 'subtype'))
    const tipo = dispatch(getCardData(cardType, 'type'))
    const data = {
      processType: 'contract',
      documentId: immHireCardNeruda.get('documentIdPolicy'),
      operationProcessId: immHireCardNeruda.get('operationProcessIdInitPolicy'),
      addressDetails: addressDetails,
      cardDetails: {
        cuentaCargo: contractNumberAccount,
        email,
        importeCuotaFormaPago: immPaymentMethod.get('value'),
        limiteSolicitado: immCreditLimit.get('creditLimit'),
        nombreAdicional: '',
        nombreBeneficiario: selectedName,
        tarjetaRef: {
          canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
          standard,
          subTipo,
          tipo,
        },
        tipoFormaPago: immPaymentMethod.get('type'),
      },
      deliverToProvidedDetails: true,
      numDomicilio,
      dataToken,
      acceptanceText,
      scrollDown: immHireCardNeruda.get('scrollDownPolicy'),

    };

    const termsAndsCondsHiringData = [
      {
        standard: cardDesignKey,
        subType: CREDIT_CARD_SUBTYPE_VISA,
        type: CREDIT_CARD_TYPE_VISA,
      },
    ];
    dispatch(updateConsents(dataToken))
      .then(() => {
        setCardHire(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving)
      }
      )
      .catch(response => {
        if (!!response.error) {
          setCardNeruda(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving);
        } else {
          throw response;
        }
      });
  };

  new Promise(() => {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  });
};

const checkRadioButton = (check) => (dispatch, getState) => {
  dispatch(hireCardNerudaCheckedRadioButton(check));
}
const checkRadioButtonPolicy = (check) => (dispatch, getState) => {
  dispatch(hireCardNerudaCheckedRadioButtonPolicy(check));
}
const checkRadioButtonIneDir = (documentsList, dmsDocumentType, documentChanges) => (dispatch, getState) => {
  dispatch(hireCardNerudaCheckedRadioButtonIneDir(documentsList, dmsDocumentType, documentChanges));
}
const printDocument = () => (dispatch, getState) => {
  dispatch(hireCardNerudaPrintDocument(true));
}
const resetPrintDocument = () => (dispatch, getState) => {
  dispatch(hireCardNerudaPrintDocument(false));
}
const printDocumentPolicy = () => (dispatch, getState) => {
  dispatch(hireCardNerudaprintDocumentPolicy());

}

const hireCardNerudaRequest = () => ({
  type: actionTypes.HIRE_CARD_CREDIT_CARD_REQUEST,
});

const hireCardNerudaSuccess = hiringStatus => ({
  type: actionTypes.HIRE_CARD_CREDIT_CARD_SUCCESS,
  payload: {
    hiringStatus,
  },
});

const hireCardNerudaFailure = (hiringStatus = '', errorMsg = '') => ({
  type: actionTypes.HIRE_CARD_CREDIT_CARD_FAILURE,
  payload: {
    errorMsg,
    hiringStatus,
  },
});



const setAllAccountsToInactive = () => ({
  type: actionTypes.HIRE_CARD_CREDIT_CARD_SET_ALL_ACCOUNTS_TO_INACTIVE,
});

const setCardNeruda = (
  dispatch,
  data,
  productAlias,
  termsAndsCondsHiringData,
  showIneAndRevolving
) => {
  const requestData = {
    header: {
      version: 2,
    },
    query: data,
  };

  dispatch(hireCardNerudaRequest());
  return APIPost({
    dispatch,
    endpoint: 'hireCreditCard',
    params: requestData,
  })
    .then(response => {
      const status = getCreditCardHiringStatus(response);

      if (status.error) {
        dispatch(hireCardNerudaFailure(status.hiringStatus, status.errorMsg));
      } else {
        dispatch(hireCardNerudaSuccess(status.hiringStatus));
        const contractNumber = get(response, ['contratoTarjetaAltOnline', 'numeroContrato'], null);
        if (showIneAndRevolving && contractNumber) {
          dispatch(
            setTermsAndCondsInfoRevolving(productAlias, termsAndsCondsHiringData, contractNumber)
          );
        } else {
          dispatch(setTermsAndCondsInfo(productAlias, termsAndsCondsHiringData));
        }
      }
    })
    .catch(response => {
      const status = getCreditCardHiringStatus(response);
      if (status.error) {
        dispatch(hireCardNerudaFailure(status.hiringStatus, status.errorMsg));
      } else if (!!response.error) {
        dispatch(hireCardNerudaFailure());
      } else {
        throw response;
      }
    });
};

const hireCardNeruda = productAlias => (dispatchPromise, getStatePromise) => {
  const callback = (dispatch, getState, dataToken) => {
    const accountId = getState().hireCreditCard.getIn(['steps', THIRD_STEP, 'accountId']);
    const accountInfo = getState().accounts.getIn(['byId', accountId, 'ibanComplex', 'codbban']);
    const immCreditLimit = getState().hireCreditLimit;
    const immPaymentMethod = getState().hirePaymentMethod;
    const cardDesignKey = getCardStandard(getState().hireCardImageSelector.get('selectedImageId'));
    const email = PersonalDataHelper.getEmail(getState().profile);
    const immShippingAddress = getState().shippingAddress;
    const shippingAddressType = immShippingAddress.get('shippingAddressType');
    const immHireCardNameSelector = getState().hireCardNameSelector;
    const selectedName = immHireCardNameSelector.getIn([
      'names',
      immHireCardNameSelector.get('selectedIndex'),
    ]);
    const immHireCardNeruda = getState().hireCreditCard;
    const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
    let addressDetails,
      numDomicilio = null;

    if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
      const immContactData = getState().hireContactData;
      addressDetails = getShippingAddressDetails(immContactData);
    } else {
      numDomicilio = immShippingAddress.getIn(['shippingAddress', 'numDomicilio']);
    }

    const data = {
      addressDetails: addressDetails,
      cardDetails: {
        cuentaCargo: accountInfo,
        email,
        importeCuotaFormaPago: immPaymentMethod.get('value'),
        limiteSolicitado: immCreditLimit.get('creditLimit'),
        nombreAdicional: '',
        nombreBeneficiario: selectedName,
        tarjetaRef: {
          canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
          standard: cardDesignKey,
          subTipo: immHireCardNeruda.get('subtype'),
          tipo: immHireCardNeruda.get('type'),
        },
        tipoFormaPago: immPaymentMethod.get('type'),
      },
      deliverToProvidedDetails: true,
      numDomicilio,
      dataToken,
    };

    const termsAndsCondsHiringData = [
      {
        standard: cardDesignKey,
        subType: immHireCardNeruda.get('subtype'),
        type: immHireCardNeruda.get('type'),
      },
    ];

    dispatch(updateConsents(dataToken))
      .then(() =>
        setCardNeruda(dispatch, data, productAlias, termsAndsCondsHiringData, showIneAndRevolving)
      )
      .catch(response => {
        if (!!response.error) {
          setCardNeruda(
            dispatch,
            data,
            productAlias,
            termsAndsCondsHiringData,
            showIneAndRevolving
          );
        } else {
          throw response;
        }
      });
  };



  new Promise(() => {
    signaturePatternActions.validateAndExecute(dispatchPromise, getStatePromise, callback);
  });
};

const setDataNerudaCard2 = (cardData) => ({
  type: actionTypes.HIRE_CARD_CREDIT_CARD_SET_DATA_CARD,
  payload: cardData,

});
const resetCheckbox = () => ({
  type: actionTypes.HIRE_CARD_CREDIT_CARD_RESET_CHECKBOX,
});
function resetCreditCardDocumentsIneDir() {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_CARD_RESET_DOCUMENTS_INE_DIR,
  }
};
const setDataNerudaCard = (cardData) => (dispatch, getState) => {
  dispatch(setDataNerudaCard2(cardData));
}

const setHireCreditCardLimit = () => (dispatch, getState) => {
  dispatch(hireCardCreditINE.getInitCardsDocuments());
  dispatch(resetCheckbox());
  dispatch(resetCreditCardDocumentsIneDir());

  dispatch(hireCreditLimitActions.resetCreditCardCheckboxCC())
  if (isPrintOfficeMode()) {
    dispatch(resetPrintDocument());
    dispatch(hireCardNerudaCheckedRadioButton(undefined));
  }
}

const resetEmailAndRadioButtonCC = () => (dispatch, getState) => {
  dispatch(hireCreditLimitActions.resetCreditCardCheckboxCC())
  dispatch(hireCardCreditINE.getInitCardsDocuments());
}
const getInitParams = (initCall, immHireCard) => (dispatch, getState) => {
  const amount = getState().hireCreditLimit.get('creditLimit');
  const productType = getState().hireCreditLimit.get('productType');
  const productSubType = getState().hireCreditLimit.get('productSubType');
  const standard = getState().hireCreditLimit.get('referenceStandard');
  const tae = getState().revolvingPersistentData.getIn(['paramsInne', 'tae']);
  const tin = getState().revolvingPersistentData.getIn(['paramsInne', 'tin']);
  const interestRate = Number(tin.replace(/%/g, '').replace(',', '.')) / 100;
  const typePayment = getState().revolvingPersistentData.getIn(['paramsAFI', 'typePayment']);
  const calculationType = getState().revolvingPersistentData.getIn(['paramsAFI', 'calculationType']);
  const fixedPaymentAmount = getState().revolvingPersistentData.getIn(['paramsAFI', 'valuePayment']);
  const paymentMethodMap = { "FixedPaymentAmount": "FIXED", "PercentagePaymentRate": "VARIABLE" };
  const paymentMethod = paymentMethodMap[typePayment] || "UNIQUE";
  const calculationTypeMap = { 0: 0, 1: 1 };
  const mappedCalculationType = calculationTypeMap[calculationType] !== undefined ? calculationTypeMap[calculationType] : 3;
  const accountId = immHireCard.getIn(['steps', SECOND_STEP, 'accountId']) || immHireCard.getIn(['steps', THIRD_STEP, 'accountId']);
  const contractNumberAccount = getState().accounts.getIn(['byId', accountId, 'ibanComplex', 'codbban']);
  const contractNumberAccountPolicy = immHireCard.get('contractNumberAccount')
  const dataAfiSimulator = paymentMethod === "FIXED" ? {
    calculationType: mappedCalculationType,
    interestRate: interestRate,
    returnFlows: false,
    fixedPaymentAmount
  } : paymentMethod === "VARIABLE" ? {
    calculationType: mappedCalculationType,
    interestRate: interestRate,
    returnFlows: false,
    percentagePaymentRate: fixedPaymentAmount
  } : {
    calculationType: mappedCalculationType,
    interestRate: interestRate,
  }
  return {
    query:
    {
      product: {
        type: productType,
        subtype: productSubType,
        standard: standard,
      },
      processType: initCall ? "contract" : "precontractual",
      dataAfiSimulator: dataAfiSimulator,
      tae: tae,
      paymentMethod: paymentMethod,
      amount: amount,
      contractNumberAccount: initCall ? contractNumberAccountPolicy : contractNumberAccount
    }
  }
}
const getInitINEstep = (immHireCard) => (dispatch, getState) => {
  const params = dispatch(getInitParams(false, immHireCard));
  const accountId = immHireCard.getIn(['steps', SECOND_STEP, 'accountId']) || immHireCard.getIn(['steps', THIRD_STEP, 'accountId']);
  const contractNumberAccount = getState().accounts.getIn(['byId', accountId, 'ibanComplex', 'codbban']);
  return APIPost({
    dispatch,
    endpoint: 'hiringCardsPreContractualInit',
    params
  })
    .then((response) => {
      dispatch(hireCardCreditInitINESuccess(response, contractNumberAccount));
      dispatch(getDocumentsCardINE(response.operationProcessId));
    })
    .catch(() => {
      dispatch(hireCardCreditInitINEError());
    });
}
const getINEDIR = () => (dispatch, getState) => {
  const immHireCreditCard = getState().hireCreditCard;
  dispatch(getInitINEstep(false, immHireCreditCard));
};
const documentRead = (documentType) => (dispatch, getState) => {

  dispatch(hireCreditCardDocumentRead(documentType));
};
const onAcceptAllDocument = () => (dispatch, getState) => {
  dispatch(hireCreditCardAllDocumentRead());
};
const saveDocumentList = (documentsList, dmsDocumentType, documentChanges) => (dispatch, getState) => {
  dispatch(hireCreditCardsaveDocumentAccepted(documentsList, dmsDocumentType, documentChanges));
};
module.exports = {
  hireCardNeruda,
  reset,
  setAccount,
  setAgreementCheckbox,
  setAllAccountsToInactive,
  setDataNerudaCard,
  setVisibleStep,
  setWillCancel,
  validate,
  validateStep,
  checkRadioButton,
  printDocument,
  processEmail,
  onHandleChangeCheckBoxCC,
  myCardsTarjetasHire,
  printDocumentPolicy,
  checkRadioButtonPolicy,
  checkRadioButtonIneDir,
  setHireCreditCardLimit,
  resetPrintDocument,
  resetEmailAndRadioButtonCC,
  getINEDIR,
  documentRead,
  onAcceptAllDocument,
  saveDocumentList,
  setCardType
};
